document.addEventListener('DOMContentLoaded', function () {
    const navContainer = document.querySelector('.news-categories-nav-container');

    if (navContainer) {
      const toggleBtn = navContainer.querySelector('.categories-toggle');
      const navList = navContainer.querySelector('.nav-list');

      if (toggleBtn && navList) {
        toggleBtn.addEventListener('click', function () {
          const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';

          toggleBtn.setAttribute('aria-expanded', !isExpanded);
          navList.classList.toggle('show');
        });
      }
    }
  });